var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 130,
    viewBox: "0 0 122 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.007 62.708C118.992 94.535 92.8018 120.119 60.7328 120.119C28.0208 120.119 1.40875 93.507 1.40875 60.797C1.40875 28.727 26.9927 2.537 58.8217 1.522C59.0237 0.651003 59.7998 0 60.7328 0C94.2568 0 121.529 27.273 121.529 60.797C121.529 61.729 120.879 62.506 120.007 62.708ZM117.598 60.797C117.598 29.441 92.0878 3.92999 60.7328 3.92999C59.8348 3.92999 59.0867 3.325 58.8517 2.504C27.5527 3.503 2.39175 29.259 2.39175 60.797C2.39175 92.966 28.5648 119.136 60.7328 119.136C92.2708 119.136 118.026 93.978 119.025 62.678C118.203 62.442 117.598 61.694 117.598 60.797ZM60.7328 74.779C53.0208 74.779 46.7487 68.507 46.7487 60.797C46.7487 53.087 53.0208 46.813 60.7328 46.813C68.4428 46.813 74.7158 53.087 74.7158 60.797C74.7158 68.507 68.4428 74.779 60.7328 74.779ZM60.7328 48.779C54.1058 48.779 48.7137 54.17 48.7137 60.797C48.7137 67.423 54.1058 72.814 60.7328 72.814C67.3588 72.814 72.7498 67.423 72.7498 60.797C72.7498 54.17 67.3588 48.779 60.7328 48.779Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0589 109.575C38.425 109.575 16.835 87.1808 16.835 59.5576H65.0589V109.575Z",
    fill: "#2E18EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0.834961,
    y: 47.5576,
    width: 80.2239,
    height: 82.0171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0999163 0 0 0 0 0.0302041 0 0 0 0 0.721517 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar4);
export default __webpack_public_path__ + "static/media/radar4.83f912279bd87b163414a461eafcdc23.svg";
export { ForwardRef as ReactComponent };